export const FETCH_TREND_MOVIES = "FETCH_TREND_MOVIES";
export const FETCH_MOVIES_FAIL = "FETCH_MOVIES_FAIL";
export const SEARCH_MOVIE_BY_TITLE = "SEARCH_MOVIE_BY_TITLE";
export const FETCH_MOVIE_DETAIL = "FETCH_MOVIE_DETAIL";
export const FETCH_POPULAR_MOVIES = "FETCH_POPULAR_MOVIES";
export const FETCH_NOW_PLAYING = "FETCH_NOW_PLAYING";
export const FETCH_TOP_RATED = "FETCH_TOP_RATED";
export const FETCH_UP_COMING_MOVIES = "FETCH_UP_COMING_MOVIES";



// WEBPACK FOOTER //
// ./src/actions/actionTypes.js